<template>
  <div
    class="relative bg-white"
    :class="[m, w, show ? 'rounded-t-3xl' : 'rounded-full']"
    v-click-outside="hide"
  >
    <div
      class="flex items-center border-gray"
      :class="[
        show
          ? 'rounded-t-3xl border-t border-l border-r'
          : 'rounded-full border',
        p
      ]"
      @click="showOptions"
    >
      <input
        class="w-9/12 outline-none"
        v-model="text"
        :placeholder="placeholder"
        autocomplete="off"
        ref="input"
      />
      <span class="arrow border-l border-gray"
        ><i class="fal fa-chevron-down"></i
      ></span>
    </div>
    <span class="text-xs absolute top-2 left-6">{{ title }}</span>
    <div
      v-if="show"
      class="list z-10 w-full max-h-64 pb-1.5 rounded-b-3xl border-b border-l border-r border-gray overflow-x-hidden overflow-y-scroll scroll"
      :class="top"
    >
      <p
        class="cursor-pointer"
        v-for="item in filtered"
        :key="item.index"
        @click="select(item)"
      >
        {{ item.name || item.label || item }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    options: {
      type: Array,
    },
    selected: {
      type: [Object, String, Array, Number],
    },
    w: {
      type: String,
      default: 'w-full',
    },
    m: {
      type: String,
      default: 'mb-5 ',
    },
    p: {
      type: String,
      default: 'pl-6 pr-2 pt-5 pb-2',
    },
    top: {
      type: String,
      default: 'top-12',
    },
    bg: {
      type: String,
      default: 'bg-white',
    },
  },
  data() {
    return {
      show: false,
      text: this.selected
        ? this.selected.name || this.selected.label || this.selected
        : null,
    };
  },
  watch: {
    selected() {
      this.text = this.selected.name || this.selected.label || this.selected;
    },
  },
  computed: {
    available() {
      if (this.selected) {
        if (typeof this.options[0] === 'object') {
          return Object.fromEntries(
            Object.entries(this.options).filter(
              (item) => item[1] != this.selected,
            ),
          );
        }
        return this.options.filter((item) => item != this.selected);
      }
      return this.options;
    },
    placeholder() {
      return !this.selected
        ? null
        : this.selected.name
          ? this.selected.name
          : this.selected.label
            ? this.selected.label
            : this.selected;
    },
    filtered() {
      if (this.text) {
        if (typeof this.options[0] === 'object') {
          return Object.fromEntries(
            Object.entries(this.available).filter(
              (item) => item[1]?.name?.includes(this.text)
                || item[1]?.label?.includes(this.text),
            ),
          );
        }
        return this.options.filter((item) => item.includes(this.text));
      }
      return this.available;
    },
  },
  methods: {
    select(item) {
      this.show = false;
      this.$emit('select', item);
      this.text = item.name || item.label || item;
    },
    hide() {
      this.show = false;
      this.text = this.selected
        ? this.selected.name || this.selected.label || this.selected
        : null;
    },
    showOptions() {
      this.$refs.input.focus();
      this.text = null;
      this.show = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  min-height: 28px;
  position: absolute;
  right: 0;
  margin: auto;
  background: #fff;

  p {
    padding: 0 1.5rem;
    height: 58px;
    display: flex;
    align-items: center;

    &:hover {
      background-color: var(--base-select--item-selected-color);
    }
  }
}

.arrow {
  padding-left: 1rem;
  font-size: 1.1em;
  cursor: pointer;
  position: absolute;
  right: 15px;
  top: 0;
  bottom: 0;
  margin: auto;
  height: 60%;
  display: flex;
  align-items: center;
}
</style>
